import { useLocation } from 'react-router-dom';

import { recordEventWithPath } from '../../../../analytics/product';

type EventType =
    | 'Saved Profile Picture'
    | 'Previewed Profile'
    | 'Clicked Edit Profile'
    | 'Clicked Close'
    | 'Clicked Tab in Profile Edit Modal'
    | 'Clicked Keep Unsaved Profile Changes'
    | 'Clicked Discard Unsaved Profile Changes'
    | 'Clicked CTA on Background Tab'
    | 'Clicked Message'
    | 'Clicked Connect'
    | 'Clicked Connections Link'
    | 'Clicked Upload Photo'
    | 'Clicked Back'
    | 'Clicked Refer'
    | 'Clicked Update';

export type BackgroundFieldItem = 'qualifications' | 'education' | 'experience';

function profileUrlObfuscation(url: string) {
    const regExp = new RegExp(/(\/profile\/)([A-Z0-9-]+)(.*$)/i);
    return url.replace(regExp, '$1*****-*****$3');
}

const useProfileRecordEvent = () => {
    const location = useLocation();

    function recordProfileEvent(
        eventName: EventType,
        attributesToLog?: Record<string, string | string[] | boolean | number>
    ) {
        const obfuscatedPath = profileUrlObfuscation(location.pathname);
        recordEventWithPath(eventName, obfuscatedPath, {
            ...attributesToLog,
        });
    }

    // phasing out events for recording field edit
    return { recordProfileEvent };
};

export default useProfileRecordEvent;
